/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Psod_ReloadInputs */

const fr_psod_reload = /** @type {(inputs: Psod_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recharger l'application`)
};

const en_psod_reload = /** @type {(inputs: Psod_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload the application`)
};

/**
* | output |
* | --- |
* | "Reload the application" |
*
* @param {Psod_ReloadInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const psod_reload = /** @type {((inputs?: Psod_ReloadInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Psod_ReloadInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_psod_reload(inputs)
	return en_psod_reload(inputs)
});